import { formatLocation } from '@/lib/utilities/Utils'
import React from 'react'
export default function ExploreShops (
  { locality, city }: { locality?: string, city?: string }
): JSX.Element {
  const formattedLocality = formatLocation(locality ?? city)
  return (
    <section className="w-full mx-0 bg-white pb-3 mt-5 md:mt-0">
      <div className="mx-auto text-center">
        <h1 className="text-xl md:text-2xl font-bold leading-tight text-[#090b20] ">
          Explore Local Shops in {formattedLocality}
        </h1>

        <p className="mx-auto mt-1 max-w-[1180px] text-base leading-tight text-[#657080]">
          Discover trusted local shops and businesses near you. Select a category to explore shops
          <span className={`${city === undefined ? 'hidden' : ''}`}>
            &nbsp;and popular localities
          </span>
          &nbsp;in&nbsp;
          <span className='font-bold text-black'>
            {formattedLocality}
          </span>.
        </p>

        <div className="mt-8 leading-tight">
          <h2 className="text-lg font-bold text-[#090b20]">
            What are you looking for?
          </h2>

          <p className="text-base text-[#657080]">
            Select a category to explore shops in <span className='font-bold text-black'>{formattedLocality}</span>
          </p>
        </div>
      </div>
    </section>
  )
}
